import { jsx as _jsx } from "react/jsx-runtime";
const App = () => {
    return (_jsx("div", { children: _jsx("h1", { children: "Hello Friends!!" }) }));
};
export default App;
